export const getEmailTextModels = payload => {
  return {
    type: "FETCH_EMAIL_MODELS",
    payload
  };
};

export const getEmailRecipients = payload => {
  return {
    type: "FETCH_EMAIL_RECIPIENTS",
    payload
  };
};

export const sendPresentationEmail = payload => {
  return {
    type: "SEND_PRESENTATION_EMAIL",
    payload
  };
};

export const getPresentationEmailHistory = payload => {
  return {
    type: "FETCH_PRESENTATION_EMAIL_HISTORY",
    payload
  };
};

export const savePresentationEmailHistory = payload => {
  return {
    type: "SAVE_PRESENTATION_EMAIL_HISTORY",
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/emailing.js